import { Component, Input, OnChanges } from "@angular/core";
import { sum } from "../../utils/sum";

@Component({
  selector: "ab-account-deploy-cards",
  templateUrl: "./deploy-cards.component.html",
})
export class AccountDeployCardsComponent implements OnChanges {
  @Input() public deployCountData: any[];
  @Input() public deploysWithErrorsCount: number;
  @Input() public dur: string;
  public deployCountList: number[];
  public totalDeploys: number;

  public ngOnChanges() {
    if (this.deployCountData) {
      this.sumStats(this.deployCountData);
    }
  }

  private sumStats(data: any[]) {
    this.totalDeploys = 0;
    this.deployCountList = [];

    for (const datum of data) {
      for (let i = 0; i < datum.length; i++) {
        if (this.deployCountList[i] === undefined) {
          this.deployCountList[i] = datum[i];
        } else {
          this.deployCountList[i] += datum[i];
        }
      }
    }

    this.totalDeploys = sum(this.deployCountList);
  }
}
